import "antd/es/button/style";
import _Button from "antd/es/button";
var _excluded = ["className", "children", "onClick", "icon", "disabled"],
    _excluded2 = ["className", "children"],
    _excluded3 = ["className", "children"],
    _excluded4 = ["className", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx } from "react/jsx-runtime";
import Typography from '../typography';
import omit from 'omit.js';
import formMethods from '../utils/form-methods';
import './style/index.less';
import { useState, useRef, useEffect } from 'react';
import { LoadingOutlined } from 'iglooicon';

var IglooButton = function IglooButton(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var mountRef = useRef(true);

  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      children = props.children,
      onClick = props.onClick,
      icon = props.icon,
      disabled = props.disabled,
      rest = _objectWithoutProperties(props, _excluded);

  useEffect(function () {
    return function () {
      mountRef.current = false;
    };
  }, []);

  var handleClick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var rst;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof onClick !== 'function')) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              mountRef.current && setLoading(true);
              rst = onClick(e);

              if (rst instanceof Promise) {
                rst.then(function () {
                  return mountRef.current && setLoading(false);
                }, function () {
                  return mountRef.current && setLoading(false);
                });
              } else {
                mountRef.current && setLoading(false);
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleClick(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return _jsx(_Button, _objectSpread(_objectSpread({
    className: "".concat(className, " igloo-button"),
    onClick: handleClick
  }, omit(rest, formMethods)), {}, {
    icon: loading ? _jsx(LoadingOutlined, {
      spinning: true
    }) : icon,
    disabled: loading || disabled,
    children: children && _jsx(Typography, {
      level: "h4",
      children: children
    })
  }));
};

IglooButton.defaultProps = _objectSpread(_objectSpread({}, _Button.defaultProps), {}, {
  type: 'default'
});

IglooButton.formItemPropsHandler = function (config) {
  return {};
};

export default IglooButton;
export var GreenButton = function GreenButton(_ref2) {
  var _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return _jsx(_Button, _objectSpread(_objectSpread({
    className: "".concat(className, " green "),
    type: "primary"
  }, rest), {}, {
    children: _jsx(Typography, {
      level: "h4",
      children: children
    })
  }));
};
export var YellowButton = function YellowButton(_ref3) {
  var _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? '' : _ref3$className,
      children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return _jsx(_Button, _objectSpread(_objectSpread({
    className: "".concat(className, " yellow "),
    type: "primary"
  }, rest), {}, {
    children: _jsx(Typography, {
      level: "h4",
      children: children
    })
  }));
};
export var RedButton = function RedButton(_ref4) {
  var _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? '' : _ref4$className,
      children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return _jsx(_Button, _objectSpread(_objectSpread({
    className: "".concat(className, " red "),
    type: "primary"
  }, rest), {}, {
    children: _jsx(Typography, {
      level: "h4",
      children: children
    })
  }));
};